module.exports = __webpack_public_path__ + "images/home/masters/law-7cc0d378b8fe35d2c24d9215088ad63c.png";